<template>
  <div class="content">
    <div class="content_swipe">
      <van-swipe :loop="true" indicator-color="#fff" @change="onChange">
        <van-swipe-item v-if="videoList.length > 0">
          <video-player
            class="video"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </van-swipe-item>
        <van-swipe-item
          v-for="(image, index) in imageList"
          :key="'img' + index"
        >
          <img class="swipe_img" :src="image" />
        </van-swipe-item>
        <template #indicator>
          <div
            v-if="videoList.length > 0 && swipeIndex == 0"
            class="custom-indicator"
          >
            视频
          </div>
          <div v-else class="custom-indicator">
            {{ videoList.length > 0 ? swipeIndex : swipeIndex + 1 }}/{{
              imageList.length
            }}
          </div>
        </template>
      </van-swipe>
    </div>

    <div class="content-wrapper-below">
      <div class="content-wrapper" v-if="houseDetailData.type == 1">
        <p class="title">
          {{ leasing_method[houseDetailData.leasing_method]
          }}{{ houseDetailData.title }}
        </p>
        <!-- 租金/户型/面积 -->
        <div class="info-row-house">
          <div class="info-row-house-item">
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price">{{ houseDetailData.price }}</div>
                <span class="detailItem_unit">元/月</span>
              </div>
              <div
                class="info-row-house-item-bottom"
                v-if="
                  houseDetailData.pledge && houseDetailData.payment_method == 4
                "
              >
                租金(押{{ houseDetailData.pledge.deposit }}付{{
                  houseDetailData.pledge.pay
                }})
              </div>
              <div v-else>
                {{ payment_method_map[houseDetailData.payment_method] }}
              </div>
            </div>
          </div>

          <div class="info-row-house-line"></div>
          <div
            class="info-row-house-item info-row-house-item-center"
            style="padding: 0 16px"
          >
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price detailItem_price_fontSize">
                  {{ room_type.room }}室{{ room_type.office }}厅{{
                    room_type.toilet
                  }}卫
                </div>
              </div>
              <div class="info-row-house-item-bottom">户型</div>
            </div>
          </div>
          <div class="info-row-house-line"></div>
          <div class="info-row-house-item info-row-house-item-center">
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price detailItem_price_fontSize">
                  {{ houseDetailData.size }}㎡
                </div>
              </div>
              <div class="info-row-house-item-bottom">面积</div>
            </div>
          </div>
        </div>
        <!-- 楼层 -->
        <div class="floorPosition">
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">楼层：</div>
            <div class="floorPosition_item_val">
              {{ houseDetailData.floor }}层(共{{
                houseDetailData.total_floor
              }}层)
            </div>
          </div>
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">朝向：</div>
            <div class="floorPosition_item_val">
              {{ houseDetailData.orientation }}
            </div>
          </div>
        </div>
        <!-- 标签 -->
        <div style="position: relative; margin-top: 12px" class="toptip">
          <div class="flex-row point-tag-hous">积分</div>
          <div class="flex-row tag-green">
            {{ lease_method[houseDetailData.lease_method] }}
          </div>
          <div
            class="flex-row tag-blue"
            v-for="(item, index) in houseDetailData.label"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <!-- 商业地产 -->
      <div class="content-wrapper" v-if="houseDetailData.type != 1">
        <p class="title">{{ houseDetailData.title }}</p>

        <!-- 租金/户型/面积 -->
        <div class="info-row-house">
          <div class="info-row-house-item">
            <div class="info-row-house-item-flex-box">
              <div
                class="info-row-house-item-top"
                v-if="houseDetailData.is_face == 1"
              >
                <div class="detailItem_price">面议</div>
              </div>
              <div class="info-row-house-item-top" v-else>
                <div class="detailItem_price">
                  {{
                    houseDetailData.daily_price
                      ? houseDetailData.daily_price.toFixed(2)
                      : ''
                  }}
                </div>
                <span class="detailItem_unit">元/天/㎡</span>
              </div>

              <div
                class="info-row-house-item-bottom"
                v-if="
                  houseDetailData.pledge && houseDetailData.payment_method == 4
                "
              >
                押{{ houseDetailData.pledge.deposit }}付{{
                  houseDetailData.pledge.pay
                }}
              </div>
              <div v-else>
                {{ payment_method_map[houseDetailData.payment_method] }}
              </div>
            </div>
          </div>
          <div class="info-row-house-line"></div>
          <div
            class="info-row-house-item info-row-house-item-center"
            style="padding: 0 16px"
          >
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div
                  class="detailItem_price detailItem_price_fontSize"
                  v-if="houseDetailData.is_face == 1"
                >
                  面议
                </div>
                <div
                  class="detailItem_price"
                  v-if="houseDetailData.is_face !== 1"
                >
                  {{ houseDetailData.price }}
                </div>
                <span
                  class="detailItem_unit"
                  v-if="houseDetailData.is_face !== 1"
                  >元/月</span
                >
              </div>
              <div class="info-row-house-item-bottom">月租金</div>
            </div>
          </div>
          <div class="info-row-house-line"></div>
          <div class="info-row-house-item info-row-house-item-center">
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price detailItem_price_fontSize">
                  {{ houseDetailData.size }}㎡
                </div>
              </div>
              <div class="info-row-house-item-bottom">面积</div>
            </div>
          </div>
        </div>

        <div class="business_house_msg">
          <div class="business_house_msg_item">
            <div class="business_house_msg_item_key">编号：</div>
            <div class="business_house_msg_item_val">
              {{ houseDetailData.id }}
            </div>
          </div>
          <div class="business_house_msg_item" v-if="houseDetailData.type == 3">
            <div class="business_house_msg_item_key">等级：</div>
            <div class="business_house_msg_item_val">
              {{ houseDetailData.attrib.constr_level }}
            </div>
          </div>
          <div class="business_house_msg_item">
            <div class="business_house_msg_item_key">类型：</div>
            <div
              class="business_house_msg_item_val"
              v-if="
                houseDetailData &&
                  houseDetailData.business &&
                  houseDetailData.business.name
              "
            >
              {{ houseDetailData.business.name }}
            </div>
            <div
              class="business_house_msg_item_val"
              v-if="
                houseDetailData.type == 2 ||
                  (houseDetailData.type == 3 &&
                    houseDetailData &&
                    houseDetailData.industry &&
                    houseDetailData.industry.name)
              "
            >
              ·{{ houseDetailData.industry.name }}
            </div>
          </div>
          <div
            class="business_house_msg_item"
            v-if="houseDetailData.type == 5 || houseDetailData.type == 4"
          >
            <div class="business_house_msg_item_key">层高：</div>
            <div class="business_house_msg_item_val">
              首层高：{{ houseDetailData.attrib.floor_height }}米
            </div>
          </div>
          <div
            class="business_house_msg_item"
            v-if="houseDetailData.type == 2 || houseDetailData.type == 3"
          >
            <div class="business_house_msg_item_key">楼层：</div>
            <div class="business_house_msg_item_val">
              {{ houseDetailData.floor_type }}(共{{
                houseDetailData.total_floor
              }}层)
            </div>
          </div>
          <div class="business_house_msg_item" v-if="houseDetailData.type == 2">
            <div class="business_house_msg_item_key">规格：</div>
            <div class="business_house_msg_item_val">
              面宽{{ houseDetailData.attrib.face_width }}m·进深{{
                houseDetailData.attrib.deep_width
              }}m·层高{{ houseDetailData.attrib.floor_height }}m
            </div>
          </div>
          <div class="business_house_msg_item">
            <div class="business_house_msg_item_key">租期：</div>
            <div
              class="business_house_msg_item_val"
              v-if="
                houseDetailData.type == 2 ||
                  houseDetailData.type == 3 ||
                  houseDetailData.type == 6
              "
            >
              {{
                houseDetailData.attrib.lease_term.srent
                  ? houseDetailData.attrib.lease_term.srent
                  : ''
              }}个月起租
            </div>
            <div
              class="business_house_msg_item_val"
              v-if="houseDetailData.type == 4 || houseDetailData.type == 5"
            >
              整租{{
                houseDetailData.attrib.lease_term.wrent
                  ? houseDetailData.attrib.lease_term.wrent
                  : ''
              }}个月起
            </div>
            <div
              class="business_house_msg_item_val"
              v-if="houseDetailData.type == 2 || houseDetailData.type == 3"
            >
              ·免租期{{
                houseDetailData.attrib.lease_term.frent
                  ? houseDetailData.attrib.lease_term.frent
                  : ''
              }}个月
            </div>
            <div
              class="business_house_msg_item_val"
              v-if="
                houseDetailData.type == 4 ||
                  (houseDetailData.type == 5 &&
                    houseDetailData.attrib.lease_term &&
                    houseDetailData.attrib.lease_term.brent)
              "
            >
              ·可分租
            </div>
          </div>
          <div class="business_house_msg_item" v-if="houseDetailData.type == 3">
            <div class="business_house_msg_item_key">使用率：</div>
            <div class="business_house_msg_item_val">
              {{ houseDetailData.attrib.utiliza_rate }}%
            </div>
          </div>
          <div class="business_house_msg_item" v-if="houseDetailData.type == 2">
            <div class="business_house_msg_item_key">客流：</div>
            <div
              class="business_house_msg_item_val"
              v-for="(item, index) in houseDetailData.attrib.guest_flow"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <!-- 标签 -->
        <div style="position: relative; margin-top: 12px" class="toptip">
          <div class="flex-row point-tag-hous">积分</div>
          <div
            class="flex-row point-tag-hous-subsidy"
            v-if="houseDetailData.is_rent_subsidy == 1"
          >
            补贴
          </div>
          <div
            class="flex-row tag-blue"
            v-if="houseDetailData.industry && houseDetailData.industry.name"
          >
            {{ houseDetailData.industry.name }}
          </div>
          <div class="flex-row tag-blue" v-if="houseDetailData.type == 2">
            免租{{ houseDetailData.attrib.lease_term.frent }}个月
          </div>
          <div
            class="flex-row tag-blue"
            v-if="
              houseDetailData.attrib &&
                houseDetailData.attrib.is_company &&
                houseDetailData.attrib.is_company == 1 &&
                houseDetailData.type == 3
            "
          >
            可注册
          </div>
          <div
            class="flex-row tag-blue"
            v-if="houseDetailData.business && houseDetailData.business.name"
          >
            {{ houseDetailData.business.name }}
          </div>
          <template
            v-if="
              (houseDetailData.introduce && houseDetailData.type == 4) ||
                houseDetailData.type == 5
            "
          >
            <div
              class="flex-row tag-blue"
              v-for="(i, j) in houseDetailData.introduce"
              :key="j"
            >
              {{ i }}
            </div>
          </template>
          <div class="flex-row tag-blue" v-if="houseDetailData.type == 6">
            {{ houseDetailData.attrib.lease_term.srent }}个月起
          </div>
        </div>
      </div>

      <div class="housing_resources">
        <div class="introduce_title">房源位置</div>
        <div class="map">
          <img
            src="../../assets/house/position@2x.png"
            class="map_icon"
            alt=""
          />
          <div class="map_position">
            <div class="map_position_address">
              {{ houseDetailData.location_address }}
            </div>
            <div
              class="map_position_metro"
              v-if="houseDetailData.is_metro == 1"
            >
              距最近的地铁{{ houseDetailData.metro_distance }}米
            </div>
          </div>
        </div>
      </div>
      <div class="housing_introduce">
        <div class="introduce_title">房屋介绍</div>
        <div class="txt-box">
          <div :class="[open ? 'open' : 'put']">
            {{ houseDetailData.describe }}
          </div>
          <div class="btn" v-if="openBtnShow">
            <div class="btn-txt" v-if="!open" @click="open = true">收起</div>
            <div class="btn-txt" v-else @click="open = false">展开</div>
          </div>
        </div>
      </div>
      <div class="housing_config">
        <div class="introduce_title">房屋配置</div>
        <div
          :class="[iconListTop.length == 5 ? 'icon_wrapper-5' : 'icon_wrapper']"
        >
          <div
            class="icon_wrapper_item"
            v-for="(item, index) in iconListTop"
            :key="index"
          >
            <house-icon
              :code="item.icon"
              size="44"
              :color="item.isChecked ? '#555555' : '#d9d9d9'"
            ></house-icon>
            <div class="icon-word" :class="[item.isChecked ? '' : 'textnone']">
              {{ item.tip }}
            </div>
          </div>
        </div>
        <div
          :class="[iconListBtm.length == 5 ? 'icon_wrapper-5' : 'icon_wrapper']"
        >
          <div
            class="icon_wrapper_item"
            v-for="(item, index) in iconListBtm"
            :key="index"
          >
            <house-icon
              :code="item.icon"
              size="44"
              :color="item.isChecked ? '#555555' : '#d9d9d9'"
            ></house-icon>
            <div class="icon-word" :class="[item.isChecked ? '' : 'textnone']">
              {{ item.tip }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isWeixin || isQQ" class="share" @click="open_mask()">
      立即咨询
    </div>
    <div v-else class="share" @click="open_app()">立即咨询</div>
    <div class="weixin-tip" v-if="maskShow">
      <p>
        <img
          v-if="!isIOS"
          src="../../assets/common/live_weixin.png"
          alt="微信打开"
        />
        <img
          v-if="isIOS"
          src="../../assets/common/live_weixin_ios.png"
          alt="微信打开"
        />
      </p>
    </div>
  </div>
</template>

<script>
import houseIcon from './components/icon.vue'
export default {
  components: {
    houseIcon,
  },
  data() {
    return {
      isIOS: false,
      isWeixin: false,
      isQQ: false,
      maskShow: false,
      id: '',
      swipeIndex: 0,
      imageList: [],
      videoList: [],
      iconListTop: [],
      iconListBtm: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, //如果true,则自动播放
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 循环播放
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

        sources: [
          {
            // 播放资源和资源格式
            type: 'video/mp4',
            src: '', //你的视频地址（先为空，之后动态赋值）
          },
        ],
        poster: '', //视频封面图
        width: document.documentElement.clientWidth, // 默认视频全屏时的最大宽度
        notSupportedMessage: '加载中...', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      payment_method_map: {
        1: '月付',
        2: '季付',
        3: '年付',
        4: '自定义',
      },
      leasing_method: {
        1: '直租' + '丨',
        2: '转租' + '丨',
      },
      lease_method: {
        1: '整租',
        2: '合租',
      },
      residenceTopList: [
        {
          icon: `&#xe614;`,
          tip: '床',
          isChecked: true,
        },
        {
          icon: '&#xe618;',
          tip: '衣柜',
          isChecked: true,
        },
        {
          icon: '&#xe616;',
          tip: '书桌',
          isChecked: false,
        },
        {
          icon: '&#xe615;',
          tip: '空调',
          isChecked: true,
        },
        {
          icon: '&#xe619;',
          tip: '微波炉',
          isChecked: true,
        },
      ],
      residenceBtmList: [
        {
          icon: '&#xe61a;',
          tip: '洗衣机',
          isChecked: false,
        },
        {
          icon: '&#xe612;',
          tip: '冰箱',
          isChecked: true,
        },
        {
          icon: '&#xe613;',
          tip: '抽油烟机',
          isChecked: true,
        },
        {
          icon: '&#xe61b;',
          tip: 'WIFI',
          isChecked: true,
        },
        {
          icon: '&#xe617;',
          tip: '热水器',
          isChecked: true,
        },
      ],
      businessTopList2: [
        {
          icon: '&#xe631;',
          tip: '下水',
          isChecked: false,
        },
        {
          icon: '&#xe62a;',
          tip: '管煤',
          isChecked: true,
        },
        {
          icon: '&#xe615;',
          tip: '中央空调',
          isChecked: true,
        },
        {
          icon: '&#xe62c;',
          tip: '可明火',
          isChecked: true,
        },
        {
          icon: '&#xe629;',
          tip: '车位',
          isChecked: true,
        },
      ],
      businessBtmList2: [
        {
          icon: '&#xe62f;',
          tip: '客梯',
          isChecked: false,
        },
        {
          icon: '&#xe630;',
          tip: '天然气',
          isChecked: true,
        },
        {
          icon: '&#xe62b;',
          tip: '380V',
          isChecked: true,
        },
        {
          icon: '&#xe62d;',
          tip: '货梯',
          isChecked: true,
        },
        {
          icon: '&#xe62e;',
          tip: '可外摆',
          isChecked: true,
        },
      ],
      businessTopList3: [
        {
          icon: '&#xe631;',
          tip: '水',
          isChecked: false,
        },
        {
          icon: '&#xe629;',
          tip: '免费车位',
          isChecked: true,
        },
        {
          icon: '&#xe62b;',
          tip: '电',
          isChecked: true,
        },
        {
          icon: '&#xe62c;',
          tip: '安全监控',
          isChecked: true,
        },
        {
          icon: '&#xe615;',
          tip: '中央空调',
          isChecked: true,
        },
      ],
      businessBtmList3: [
        {
          icon: '&#xe62f;',
          tip: '电梯',
          isChecked: false,
        },
        {
          icon: '&#xe616;',
          tip: '办公家具',
          isChecked: true,
        },
        {
          icon: '&#xe61b;',
          tip: '宽带',
          isChecked: true,
        },
        {
          icon: '&#xe62e;',
          tip: '员工餐厅',
          isChecked: true,
        },
        {
          icon: '&#xe62c;',
          tip: '电话',
          isChecked: true,
        },
      ],
      businessTopList4: [
        {
          icon: '&#xe631;',
          tip: '水',
          isChecked: false,
        },
        {
          icon: '&#xe62b;',
          tip: '电',
          isChecked: true,
        },
      ],
      businessBtmList4: [],
      businessTopList5: [],
      businessBtmList5: [
        {
          icon: '&#xe631;',
          tip: '水',
          isChecked: false,
        },
        {
          icon: '&#xe62b;',
          tip: '电',
          isChecked: true,
        },
      ],
      businessTopList6: [],
      businessBtmList6: [],
      houseDetailData: {},
      isLike: false,
      room_type: {},
      open: true,
      openBtnShow: true,
      shareShow: false,
      parmSrc: '',
    }
  },
  created() {
    this.id = this.$route.query.id
    var u = navigator.userAgent
    this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1 // 微信内
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (
      u.toLowerCase().indexOf('qq') > -1 &&
      u.toLowerCase().indexOf('mqqbrowser') < 0 &&
      this.isIOS
    ) {
      //qq内置浏览器
      this.isQQ = true
    }
    this.getHouseDetail()
  },
  methods: {
    // 获取房源详情
    getHouseDetail() {
      this.$api
        .get('estate/index/estates/detail', {
          id: this.id,
          source: 1,
        })
        .then((res) => {
          if (res.describe.length > 70) {
            this.openBtnShow = true
          } else {
            this.openBtnShow = false
          }
          if (res) {
            if (res.type == 1) {
              this.iconListTop = this.residenceTopList
              this.iconListBtm = this.residenceBtmList
            } else if (res.type == 2) {
              this.iconListTop = this.businessTopList2
              this.iconListBtm = this.businessBtmList2
            } else if (res.type == 3) {
              this.iconListTop = this.businessTopList3
              this.iconListBtm = this.businessBtmList3
            } else if (res.type == 4) {
              this.iconListTop = this.businessTopList4
              this.iconListBtm = this.businessBtmList4
            } else if (res.type == 5) {
              this.iconListTop = this.businessTopList5
              this.iconListBtm = this.businessBtmList5
            } else if (res.type == 6) {
              this.iconListTop = this.businessTopList6
              this.iconListBtm = this.businessBtmList6
            }
            this.houseDetailData = res
            this.room_type = res.room_type
            // 房屋介绍
            this.iconListTop.forEach((item) => {
              if (res.introduce.indexOf(item.tip) != -1) {
                item.isChecked = true
              } else {
                item.isChecked = false
              }
            })
            this.iconListBtm.forEach((item) => {
              if (res.introduce.indexOf(item.tip) != -1) {
                item.isChecked = true
              } else {
                item.isChecked = false
              }
            })
            this.iconListTop = [...this.iconListTop]
            this.iconListBtm = [...this.iconListBtm]
            this.addImgs(res.type)
          }
        })
    },
    addImgs(type) {
      if (
        this.houseDetailData.image.video != null &&
        this.houseDetailData.image.video.length != 0
      ) {
        this.houseDetailData.image.video.forEach((item) => {
          this.videoList.push(item)
        })
        this.playerOptions['sources'][0][
          'src'
        ] = this.houseDetailData.image.video[0]
      }
      if (type == 1) {
        // 客厅图
        this.houseDetailData.image.living_room.forEach((item) => {
          this.imageList.push(item)
        })
        // 卧室
        this.houseDetailData.image.bedroom.forEach((item) => {
          this.imageList.push(item)
        })
        // 卫生间
        this.houseDetailData.image.toilet.forEach((item) => {
          this.imageList.push(item)
        })
        // 厨房
        this.houseDetailData.image.kitchen.forEach((item) => {
          this.imageList.push(item)
        })
        // 户型图
        this.houseDetailData.image.diagram.forEach((item) => {
          this.imageList.push(item)
        })
        // 其它
        this.houseDetailData.image.other.forEach((item) => {
          this.imageList.push(item)
        })
      } else {
        this.houseDetailData.image.living_room.forEach((item) => {
          this.imageList.push(item)
        })
        // 其它
        this.houseDetailData.image.other.forEach((item) => {
          this.imageList.push(item)
        })
      }
    },
    onChange(index) {
      if (this.videoList.length > 0) {
        this.$refs.videoPlayer.player.pause()
      } else {
      }
      this.swipeIndex = index
    },
    open_app() {
      let baseUrl = process.env.VUE_APP_WEEX_HOST
      this.parmSrc = `house/index?house_js=${baseUrl}/businessHouseDetails.js?id=${this.id}&baseUrl=${baseUrl}`
      this.openApp('', '', this.parmSrc)
    },
    open_mask() {
      this.maskShow = true
    },
  },
}
</script>

<style lang="less" scoped>
.housing_resources {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px 1px;
  margin-top: 8px;
}

.housing_introduce {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px 1px;
  margin-top: 8px;
}

.housing_config {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px;
  margin-top: 8px;
  padding-bottom: 70px;
}

.introduce_title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.content {
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  overflow: auto;
  background-color: #f6f6f6;
}

.content_swipe {
  width: 100%;
  height: 282px;

  .van-swipe,
  .swipe_img,
  .video {
    width: 100%;
    height: 100%;
  }
}

/deep/.vjs-tech {
  height: 282px;
}

/deep/.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 282px;
}

/deep/.video-js .vjs-big-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-indicator {
  position: absolute;
  right: 16px;
  bottom: 28px;
  width: 55px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  font-weight: 600;
  border-radius: 17px;
  background-color: rgba(0, 0, 0, 0.2);
}

.content-wrapper-below {
  width: 375px;
  position: absolute;
  background-color: rgba(245, 245, 245, 1);
}

.content-wrapper {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px 16px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin-top: -12px;
  z-index: 10;
}

.title {
  font-size: 17px;
  font-weight: 600;
  color: #333333;
  vertical-align: middle;
}

.toptip {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.point-tag-hous {
  width: 34px;
  height: 21px;
  background-color: rgba(255, 239, 239, 1);
  font-size: 12px;
  color: rgba(255, 78, 78, 1);
  border-radius: 2px;
}

.point-tag-hous-subsidy {
  width: 34px;
  height: 21px;
  font-size: 12px;
  background-color: rgba(255, 243, 231, 1);
  color: rgba(234, 120, 0, 1);
}

.tag-green {
  min-width: 32px;
  height: 21px;
  margin-left: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #7594b7;
  background-color: #eef8ff;
  border-radius: 2px;
}

.tag-blue {
  min-width: 32px;
  padding: 0 8px;
  height: 21px;
  margin-left: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #7594b7;
  background-color: #eef8ff;
  border-radius: 2px;
}

.info-row-house {
  padding: 16px 0;
  // margin: 16px 0 10px;
  display: flex;
  align-items: center;

  .info-row-house-item {
    display: flex;
    flex: 1;
  }

  .info-row-house-item-flex-box {
    display: flex;
    flex-direction: column;
  }

  .info-row-house-item-start {
    justify-content: flex-start;
  }

  .info-row-house-item-center {
    justify-content: center;
  }

  .info-row-house-item-top {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
  }

  .detailItem_price {
    font-size: 1.2em;
    font-weight: 600;
    color: #e94b4b;
    line-height: 17px;
  }

  .detailItem_price_fontSize {
    font-size: 1.2em;
  }

  .detailItem_unit {
    font-size: 12px;
    color: #e94b4b;
    display: inline-block;
    margin-left: 5px;
    line-height: 10px;
  }

  .info-row-house-item-bottom {
    font-size: 12px;
    color: #999999;
  }

  .info-row-house-line {
    height: 32px;
    width: 1px;
    background-color: #eaeaea;
  }
}

.floorPosition {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.floorPosition_item {
  display: flex;
  flex-direction: row;
}

.floorPosition_item:first-child {
  margin-right: 70px;
}

.floorPosition_item_key {
  font-size: 14px;
  color: #999999;
}

.floorPosition_item_val {
  font-size: 14px;
  color: #333333;
}

.map {
  padding: 14px;
  margin: 20px 0;
  background: #fafbfd;
  border-radius: 2px;
  border: 1px solid #eef2fb;
  display: flex;
  align-items: center;

  .map_icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .map_position {
    display: flex;
    flex-direction: column;

    .map_position_address {
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }

    .map_position_metro {
      min-height: 14px;
      font-size: 12px;
      color: #999999;
    }
  }
}

.business_house_msg_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;

  .business_house_msg_item_key {
    font-size: 14px;
    color: #999999;
  }

  .business_house_msg_item_val {
    font-size: 14px;
    color: #333333;
  }
}

.introduce_title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.txt-box {
  display: flex;
  flex-direction: column;
  margin: 16px 0 24px;

  .btn {
    font-size: 14px;
    color: #527ba7;
    line-height: 20px;
  }
}

.open {
  min-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.put {
  height: 66px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.icon_wrapper-5 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
}

.icon_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 15px;
}

.icon_wrapper_item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // min-width: 70px;
}

.icon-word {
  color: #555555;
}

.textnone {
  color: #d9d9d9;
  text-decoration: line-through;
}

.share {
  width: 222px;
  height: 40px;
  position: fixed;
  bottom: 39px;
  left: 50%;
  transform: translateX(-50%);
  background: #26c165;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
}

.weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  p {
    padding: 15px 25px;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
